import {
    convertCategory,
    isHasProcedureBelongToCategory,
} from '../../modules/actions/categoryActions';
import { bodyAreaSelected, categories, showBodyAreaSelection, scopeProceduresToSelectedLocation } from '../../utils/variables';

export function loadCategories(procedures) {
    procedures = scopeProceduresToSelectedLocation(procedures);
    let categoryArray = [];
    const categoryWrapper = document.querySelector(
        '.seeServices__container .category_wrapper'
    );
    const listCategory = bodyAreaSelected?.map(item => item.name);


    let categoriesList = categories.filter((i) => {
        if (showBodyAreaSelection && !listCategory.includes(i.name)) {
            return false;
        }
        return isHasProcedureBelongToCategory(i, procedures);
    });

    for (const i of categoriesList) {
        categoryArray.push(i.name);
    }

    categoryWrapper.innerHTML = '';

    /* The horizontal chip carousel is now always hidden: with more than one
       category the services list renders as a collapsible category menu (see
       loadProcedures) so the chips are redundant, and with a single category
       one chip jumping to the only section is pure noise (the section header
       is suppressed too, in loadProcedures). */
    const categoryBar = document.querySelector('.seeServices__container .category');
    if (categoryBar) {
        categoryBar.classList.add('category--hidden');
    }
    return;

    for (const i of categoryArray) {
        if (!categoryArray.indexOf(i)) {
            /* The first is default selected */
            categoryWrapper.insertAdjacentHTML(
                'beforeend',
                `
                <div class="category__option category__option--selected" data-id="${convertCategory(
                    i
                )}">${i}</div>
            `
            );
        } else {
            categoryWrapper.insertAdjacentHTML(
                'beforeend',
                `
                <div class="category__option" data-id="${convertCategory(
                    i
                )}">${i}</div>
            `
            );
        }
    }

    /* Click category */
    document.querySelectorAll('.category__option').forEach((i) => {
        i.addEventListener('click', handleCategoryOptionClickEvent);
    });
}

function handleCategoryOptionClickEvent() {
    const containerOffset = document.querySelector(
        '.procedures__container'
    ).offsetTop;
    const targetOffset = document.querySelector(
        `#${this.getAttribute('data-id')}`
    ).offsetTop;
    const scrollOffset = targetOffset - containerOffset;
    document.querySelector('.procedures__container').scrollTop = scrollOffset;
}
